var map = {
	"./amex-card.svg": 2503,
	"./diners-card.svg": 7147,
	"./discover-card.svg": 6952,
	"./jcb-card.svg": 2177,
	"./mastercard-card.svg": 998,
	"./unionpay-card.svg": 9543,
	"./unknown-card.svg": 8952,
	"./visa-card.svg": 2092
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2976;